import { videos, type VideoItem } from "@/mocks/videos";
import { specials } from "@/mocks/specials";
import { categories } from "@/mocks/categories";

export function getVideoById(id: string): VideoItem | undefined {
  return videos.find((v) => v.id === id);
}

export function getVideosByIds(ids: string[]): VideoItem[] {
  return ids
    .map((id) => videos.find((v) => v.id === id))
    .filter((v): v is VideoItem => Boolean(v));
}

export function getVideosByCategory(categoryId: string): VideoItem[] {
  return videos.filter((v) => v.category === categoryId);
}

export function getCategoryById(id: string) {
  return categories.find((c) => c.id === id);
}

export function getSpecialById(id: string) {
  return specials.find((s) => s.id === id);
}

export function getRelatedVideos(video: VideoItem, limit = 4): VideoItem[] {
  const sameTag = videos.filter(
    (v) => v.id !== video.id && v.tags.some((t) => video.tags.includes(t)),
  );
  const sameCategory = videos.filter(
    (v) => v.id !== video.id && v.category === video.category && !sameTag.includes(v),
  );
  return [...sameTag, ...sameCategory].slice(0, limit);
}

export function searchVideos(keyword: string): VideoItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return videos.filter((v) => {
    const haystack = [v.title, v.description, v.author, ...v.tags].join(" ").toLowerCase();
    return haystack.includes(kw);
  });
}

export function formatCount(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  return String(n);
}

export function parseDuration(duration: string): number {
  const parts = duration.split(":").map((p) => Number(p));
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  return 0;
}

export function getHotVideos(limit = 6): VideoItem[] {
  return [...videos].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestVideos(limit = 6): VideoItem[] {
  return [...videos]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}

export function getAllTags(): string[] {
  const set = new Set<string>();
  videos.forEach((v) => v.tags.forEach((t) => set.add(t)));
  return Array.from(set);
}